// uses window by infra2 standards whenever is set
var rootEnv = window['LUCID_SPA_CONFIG'] || process.env;
export var REACT_APP_SPLIT_IO_KEY = rootEnv.REACT_APP_SPLIT_IO_KEY || '';
//# sourceMappingURL=env.js.map